import React from 'react';
import { Spinner } from 'takeat-design-system-ui-kit';
import {
  QRLoadingContainer,
  QRLoadingText,
  QRCodeDisplayContainer,
  QRCodeImage,
  ProgressBarContainer,
  ProgressBar,
  CountdownTextContainer,
  CountdownText,
  QRContainer,
  InstructionsContainer,
  InstructionsText,
  SmallerInstructionsText,
} from './styles';
import useWhatsappStore from 'store/whatsappStore';

const QRLoading = () => (
  <QRContainer>
    <QRLoadingContainer>
      <Spinner />
      <QRLoadingText>Aguardando QR Code...</QRLoadingText>
    </QRLoadingContainer>
  </QRContainer>
);

const QRCodeDisplay = ({ code, countdown, COUNTDOWN_TIME }) => (
  <QRContainer>
    <QRCodeDisplayContainer>
      <QRCodeImage src={code} alt="WhatsApp QR Code" />
      <ProgressBarContainer>
        <ProgressBar
          percentage={(countdown / COUNTDOWN_TIME) * 100}
          countdown={countdown}
        />
      </ProgressBarContainer>
      <CountdownTextContainer>
        <CountdownText>
          QR Code irá expirar em {countdown} segundos
        </CountdownText>
      </CountdownTextContainer>
    </QRCodeDisplayContainer>
  </QRContainer>
);

const QRUnavailable = () => (
  <InstructionsContainer>
    <InstructionsText>
      {`Abra o WhatsApp no celular
  - Android: Clique nos três pontinhos
  - iPhone: Clique em Configurações
Vá em Dispositivos conectados → Conectar dispositivo
Clique em Iniciar conexão aqui na tela
Escaneie o QR Code com a câmera do celular`}
    </InstructionsText>
    <SmallerInstructionsText>
      Pronto! Vai aparecer no seu WhatsApp um dispositivo chamado{' '}
      <strong style={{ color: '#2EC9B7' }}>Takeat</strong>
    </SmallerInstructionsText>
  </InstructionsContainer>
);

/* ------------------------- QR + start button area ------------------------- */
function QRArea({
  wppQrcode,
  countdown,
  COUNTDOWN_TIME,
  isValidQrCode,
  loadingQrCode,
  waitingForWebhook,
}) {
  const code = wppQrcode;
  const valid = isValidQrCode ? isValidQrCode(code) : !!code;
  const { wppStatus } = useWhatsappStore();
  const isConnecting = wppStatus === 'created' || wppStatus === 'connecting';

  const shouldShowSpinner =
    loadingQrCode &&
    (waitingForWebhook || !(isValidQrCode ? isValidQrCode(code) : !!code));

  if (shouldShowSpinner) {
    return <QRLoading />;
  }

  if (valid) {
    return (
      <>
        <InstructionsContainer>
          <SmallerInstructionsText>
            Escaneie o QR Code com a câmera do celular
          </SmallerInstructionsText>
        </InstructionsContainer>
        {isConnecting && (
          <QRCodeDisplay
            code={code}
            countdown={countdown}
            COUNTDOWN_TIME={COUNTDOWN_TIME}
          />
        )}
        <InstructionsContainer>
          <SmallerInstructionsText>
            Pronto! Vai aparecer no seu WhatsApp um dispositivo chamado{' '}
            <strong style={{ color: '#2EC9B7' }}>Takeat</strong>
          </SmallerInstructionsText>
        </InstructionsContainer>
      </>
    );
  }

  return <QRUnavailable />;
}

export default QRArea;
